var exports = {
  "nv": "ChecksStatusBadgeButton__eiY6lv",
  "N0": "ChecksStatusBadgeLinkButton__ewKeYy",
  "ey": "ChecksStatusBadgeIconButton__O8V97i",
};

module.exports = exports;
